import React from 'react'
import { Layout, Header, Social, Seo } from '../components'
import { css } from '@emotion/react'
import { useForm, ValidationError } from '@formspree/react'

const ContactPage = () => {
  const [state, handleSubmit] = useForm('mqkwbwpn')
  if (state.succeeded) {
    return (
      <p
        css={css`
          text-align: center;
        `}
      >
        Thanks for contacting us! We'll be in touch shortly.
      </p>
    )
  }

  return (
    <Layout>
      <Seo
        title="Contact Page"
        description="Contact page for the Great Dev Co. Contacts us and lets chat about your project needs"
      />
      <Header text="Contact us, we’d love to chat about your project needs" />
      {/* form */}
      <div
        className="contact-form"
        css={css`
          margin: 5rem 0;

          input,
          textarea {
            display: block;
            width: 100%;
            margin-top: 2rem;
            padding: 1rem 1rem 1rem 0;
            border: transparent;
            border-bottom: 1px solid var(--color-primary);
          }

          @media screen and (min-width: 768px) {
            .inputs {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              grid-gap: 1rem;
            }
          }
        `}
      >
        <form onSubmit={handleSubmit}>
          <div className="inputs">
            <label htmlFor="name">
              <input type="text" placeholder="Name" name="name" id="name" required />
              <ValidationError prefix="Name" field="name" errors={state.errors} />
            </label>
            <label htmlFor="email">
              <input type="email" placeholder="Email Address" name="email" id="email" required />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </label>
          </div>

          <label htmlFor="message">
            <textarea name="message" id="message" cols="30" rows="10" placeholder="Message"></textarea>
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </label>
          <button type="submit" className="btn">
            Send Message
          </button>
        </form>
      </div>
      <Social margin />
    </Layout>
  )
}

export default ContactPage
